export default {
  label: {
    time: 'tìm kiếm theo thời gian',
    orderNo: 'tìm kiếm theo mã giao dịch',
    systemOrderNo: 'mã giao dịch',
    context: '上下文',
    createTime: 'thời gian tạo',
    id: 'mã chính ID',
    message: 'Mô tả',
    params: 'yêu cầu tham số',
    request: 'yêu cầu đường dẫn hoặc url',
    response: 'kết quả phản hồi',
    step: 'bước',
    timeline: 'khoảng thời gian',
    callback: 'địa chỉ gọi lại',
    callbackParams: 'tham số gọi lại'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/transactionRecord.js